export enum AssessmentQuestionActionType {
  UpdateMultipleChoice,
  UpdateTextField,
  UpdateFileUpload,
  Init
}

interface InitAction {
  type: AssessmentQuestionActionType.Init,
  payload: {
    data: any[]
  }
}

interface UpdateMultipleChoiceAction {
  type: AssessmentQuestionActionType.UpdateMultipleChoice,
  payload: {
    question_index: number,
    answer: number[],
    answerId?: number
  }
}

interface UpdateTextFieldAction {
  type: AssessmentQuestionActionType.UpdateTextField,
  payload: {
    question_index: number,
    answer: string
    answerId?: number
  }
}

interface UpdateFileUploadAction {
  type: AssessmentQuestionActionType.UpdateFileUpload,
  payload: {
    question_index: number,
    answer: string
    answerId?: number
  }
}

// export interface AssessmentQuestionAction {
//   payload: {
//     question_index: number,
//     answer: string | number | null
//   }
// }

export type AssessmentQuestionAction = UpdateMultipleChoiceAction | UpdateTextFieldAction | UpdateFileUploadAction | InitAction;